import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, TextField, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import { Context } from '../context/DataContext';

const MobileVerifyPage = () => {
  const navigate = useNavigate();
  const [verifyCode, setVerifyCode] = React.useState('');
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const {
    state,
    checkSMSCode,
    getInsuranceDocInfo,
    saveOrderInsurance,
    setCustomerInfo,
    setEmployeeInfo,
    sendSMSMessage,
  } = React.useContext(Context);
  const {
    customerInfo: {
      orderId,
      phone,
      payType,
      insurancePrice,
      serviceName,
      paymentText,
      fromDate,
      toDate,
      swapPrice,
      periodType,
      validPeriod,
      isSendOrderInsurance,
      previousInsuranceNo,
    },
    loginInfo: { empNo },
  } = state;

  const handleSubmit = () => {
    setErrorMsg('');
    if (isSendOrderInsurance) {
      navigate('/check-pdf');
    } else {
      setLoading(true);
      // check verify code is correct or not with api
      checkSMSCode(
        { orderId, phone, code: verifyCode },
        ({ responseCode, responseMsg }) => {
          if (responseCode === '000') {
            // Get Insurance Doc Info
            getInsuranceDocInfo(
              {
                orderId,
                payType,
                userId: empNo,
                insurancePrice,
                serviceName,
                periodType,
              },
              (data) => {
                const { ResponseCode, ResponseMSG } = data;

                if (ResponseCode === '1') {
                  const {
                    InsuranceAgentAutography,
                    InsuranceAgentName,
                    InsuranceNo,
                    SellingPrice,
                    RepCenterName,
                    LicenseNo,
                    TimesOfRMA,
                  } = data;

                  // SaveOrderInsurance then save to context
                  saveOrderInsurance(
                    {
                      orderId,
                      employeeCode: LicenseNo,
                      fromDate,
                      insuranceAgentName: InsuranceAgentName,
                      insuranceNo: InsuranceNo,
                      insurancePrice,
                      operator: empNo,
                      payment: payType,
                      paymentText,
                      periodType,
                      phonePrice: SellingPrice,
                      repairTarget: RepCenterName,
                      serviceName,
                      swapPrice,
                      toDate,
                      validPeriod,
                      previousPolicyNumber: previousInsuranceNo || '',
                    },
                    ({ responseCode, responseMsg }) => {
                      if (responseCode === '000') {
                        setEmployeeInfo(
                          {
                            previousSign: InsuranceAgentAutography,
                            empName: InsuranceAgentName,
                            empCode: LicenseNo,
                          },
                          () => {
                            setCustomerInfo(
                              {
                                repairTarget: RepCenterName,
                                phonePrice: SellingPrice,
                                insuranceNo: InsuranceNo,
                                repairCount: TimesOfRMA,
                                isSendOrderInsurance: true,
                              },
                              () => {
                                setLoading(false);
                                navigate('/check-pdf');
                              }
                            );
                          }
                        );
                      } else {
                        setLoading(false);
                        setErrorMsg(responseMsg);
                      }
                    }
                  );
                } else {
                  setLoading(false);
                  setErrorMsg(ResponseMSG);
                }
              }
            );
          } else {
            setLoading(false);
            setErrorMsg(responseMsg);
          }
        }
      );
    }
  };

  return (
    <Box>
      <Typography variant='h4' sx={{ my: 2 }}>
        手機認證
      </Typography>
      <Box component='form' sx={{ px: 3, pb: 8 }} noValidate autoComplete='off'>
        <Typography variant='h5' sx={{ my: 2 }}>
          {phone}
        </Typography>
        <Box sx={{ mb: 3 }}>
          <Button
            sx={{ mr: 3 }}
            color='info'
            variant='contained'
            onClick={() => {
              // send sms with api
              sendSMSMessage({
                orderId,
                createBy: empNo,
                memberNo: phone,
                mobile: phone,
                sendFor: '5',
              });
            }}
          >
            取得認證碼
          </Button>
          <Button
            color='error'
            variant='contained'
            onClick={() => {
              // resend sms with api
              sendSMSMessage({
                orderId,
                createBy: empNo,
                memberNo: phone,
                mobile: phone,
                sendFor: '5',
              });
            }}
          >
            重送
          </Button>
        </Box>
        <TextField
          fullWidth
          id='verify-code'
          label='認證碼'
          value={verifyCode}
          onChange={(e) => setVerifyCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSubmit();
            }
          }}
        />
        {errorMsg ? (
          <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <LoadingButton
          variant='contained'
          sx={{ width: 168, mt: 3 }}
          disabled={!verifyCode}
          loading={loading}
          onClick={handleSubmit}
        >
          下一步
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default MobileVerifyPage;
